<template>
	<div class="notice_popup prj_itv pass">
		<div class="close">
			<img class="ml-0" src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<tec-summary tagNm="div" class="member" :value="data" />
		<div class="tit">프로젝트 인터뷰 결과</div>
		<div class="itv_date">
			<SelectComp type="radio" v-model="actlIntvYn" list="Y:인터뷰 완료,N:인터뷰 없음"/>
		</div>
		<img src="/images/admin/pop_itv_pass.png" alt="합격">
		<div class="itv_date">
			<p>참여기간</p><br/>
			<SelectDate tagNm="div" classY="wd01" class="select-box" type="date" v-model="data.joinStartYyyymmdd" from="Y-3" :to="data.joinEndYyyymmdd || 'Y3'" rules="required" v-if="data.mberSeq">
				<template v-slot:after> 부터</template>
			</SelectDate>
			<SelectDate tagNm="div" classY="wd01" class="select-box" type="date" v-model="data.joinEndYyyymmdd" :from="data.joinStartYyyymmdd || 'Y-3'" to="Y3" rules="required" v-if="data.mberSeq">
				<template v-slot:after> 까지</template>
			</SelectDate>
		</div>

		<div class="itv_date rank">
			<p>투입등급</p>
			<SelectComp tagName="div" class="select_rank" type="radio" title="투입등급" v-model="data.projectJoinTechGradeCd" cdId="PRO106" rules="required" v-if="data.mberSeq" :showError="false"/>
		</div>
		<div class="qs">위의 정보로 IT프로의 인터뷰 상태를 변경하시겠습니까?</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close', false)">취소</div>
			<div class="btn" @click="save">예</div>
		</div>
	</div>
</template>
<script>
import tecSummary from "@/components/highpro/TecSummary.vue";

export default {
	components: { tecSummary },
	props: { param:Object },
	data() {
		return {
			data: {},
			actlIntvYn : '',
		};
	},
	mounted(){
		var projectSeq = this.param.projectSeq;
		var tecMberSeq = this.param.tecMberSeq;
		var interviewReqSeq = this.param.interviewReqSeq;
		this.$.httpPost('/api/prj/adm/getPrjMberInfo', {projectSeq, tecMberSeq, interviewReqSeq})
			.then(res => {
				this.data = res.data;
				this.$emit('updated');
			}).catch(this.$.httpErrorCommon);

			this.corpSearch();	

	},
	methods: {
		corpSearch() {
            var param = {
				order : 'asc'
            }
			this.$.httpPost('/api/prj/adm/getScoList', param)
				.then(res => {
					this.corpList = res.data;
				}).catch(this.$.httpErrorCommon);
		},

		save(){

			if(this.actlIntvYn == '') {
				alert('인터뷰 여부를 선택하지 않았습니다.');
				return;
			}

			var interviewReqSeq = this.data.interviewReqSeq;
			var tecMberSeq		= this.param.tecMberSeq;
			var joinStartYyyymmdd	= this.data.joinStartYyyymmdd;
			var joinEndYyyymmdd		= this.data.joinEndYyyymmdd;
			var projectJoinTechGradeCd = this.data.projectJoinTechGradeCd;
			var workCont = this.param.workCont;
			var actualInterviewYn = this.actlIntvYn;

			var param = {
				interviewReqSeq, tecMberSeq, joinStartYyyymmdd, joinEndYyyymmdd, projectJoinTechGradeCd, workCont, actualInterviewYn
			};

			this.$.httpPost('/api/prj/adm/saveInterviewPass', param)
			.then(() => {
				alert('합격 처리가 완료되었습니다.')
				this.$emit('close', true);
			}).catch(this.$.httpErrorCommon);
			
		}
	},
};
</script>
